import { AssetApi, Configuration } from '@/rest'
import { FramePuzzleModule, CollageInfo, CollageUsageAndInfo, PuzzleBoxUpdateState } from '../../../../store/modules/framePuzzle';
import { AppModule } from '../../../../store/modules/app';
import { Asset } from '@/rest/models'

export default function updateAssetAttributes(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        let assetApi = new AssetApi(
            new Configuration({ basePath: '/rest' })
        )
        var allCollages: CollageUsageAndInfo = FramePuzzleModule.allCollages
        var done = 0
        Object.keys(allCollages).forEach(function (key, index) {
            let collageAsset = allCollages[key]
            if (collageAsset.attributesNeedUpdate) {
                var matches = key.match(/\d+$/);
                var pos = index;
                if (matches) {
                    pos = Number(matches[0])
                }
                if (pos <= 1) {
                    let asset: Asset = {};
                    asset.id = collageAsset.assetId
                    asset.rotation = collageAsset.rotation
                    asset.ll = collageAsset.boundingBox.ll
                    asset.ur = collageAsset.boundingBox.ur
                    asset.pieces = FramePuzzleModule.parts
                    if (asset.ur && asset.ur.length > 1 && asset.ll && asset.ll.length > 1) {
                        let height = asset.ur[1] - asset.ll[1];
                        let width = asset.ur[0] - asset.ll[0];
                        asset.format = height > width ? "H" : "Q"
                    }

                    let info: CollageInfo = new CollageInfo(collageAsset.assetId, collageAsset.boundingBox, collageAsset.rotation, false)
                    let sessionId = ""
                    if (AppModule.session && AppModule.session.sessionId) {
                        sessionId = AppModule.session.sessionId
                    }
                    let request = { 'customProductType': "FPU", 'asset': asset, "sessionId": sessionId }
                    assetApi.updateAssetAttributes(request).then(
                        (responseValue) => {
                            if (responseValue != "" + asset.id) {
                                info.assetId = +responseValue
                            }
                            FramePuzzleModule.SetCollageUsageAndInfo(['frameimage', info])
                            done++
                            if (done == Object.keys(allCollages).length) {
                                FramePuzzleModule.SetPuzzleBoxUpdateState(PuzzleBoxUpdateState.UPDATING_BOX_ASSET)
                                resolve()
                            }
                        },
                        (reason) => {
                            window.console.log(reason)
                            reject()
                        });
                }
            } else {
                done++
                if (done == Object.keys(allCollages).length) {
                    FramePuzzleModule.SetPuzzleBoxUpdateState(PuzzleBoxUpdateState.UPDATING_BOX_ASSET)
                    resolve()
                }
            }
        });
        reject()
    });
}